module.exports = __webpack_public_path__ + "media/customizations/trilith/back-895776862808c9c281291f03120524bd.jpg";